import { render, staticRenderFns } from "./ApiTree.vue?vue&type=template&id=3ade97ad&scoped=true"
import script from "./ApiTree.vue?vue&type=script&lang=js"
export * from "./ApiTree.vue?vue&type=script&lang=js"
import style0 from "./ApiTree.vue?vue&type=style&index=0&id=3ade97ad&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ade97ad",
  null
  
)

export default component.exports